module.exports = __webpack_public_path__ + "img/Monte_Kope_7.3d71f21a.jpg";